import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getBulkCloudMigrationOptIn } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
import { useAsync } from 'react-async';
const transformCloudMigrationOptInData = (partnerApps, cloudMigrationTrialApps) => {
  return cloudMigrationTrialApps && partnerApps.reduce((cmtMapping, partnerApp) => {
    const cloudMigrationDataForApp = cloudMigrationTrialApps.find(cmtApp => cmtApp.appKey === partnerApp.key);
    if (cloudMigrationDataForApp) {
      cmtMapping[cloudMigrationDataForApp.appKey] = _objectSpread({}, cloudMigrationDataForApp);
    }
    return cmtMapping;
  }, {});
};
export const useCloudMigrationData = (mpacBaseUrl, partnerApps, enableCloudMigrationToggle) => {
  const promiseFn = useCallback(_ => {
    if (partnerApps !== null && partnerApps !== void 0 && partnerApps.count && enableCloudMigrationToggle) {
      const partnerAppKeys = partnerApps.apps.map(app => app.key);
      return getBulkCloudMigrationOptIn(mpacBaseUrl, {
        appKeys: partnerAppKeys
      }).then(response => {
        return transformCloudMigrationOptInData(partnerApps.apps, response.values);
      }).catch(error => {
        log.error('getBulkCloudMigrationOptIn', "Failed to fetch Cloud Migration Opt In Data", {
          error
        });
        return error;
      });
    }
  }, [partnerApps, enableCloudMigrationToggle]);
  const {
    data
  } = useAsync({
    promiseFn
  });
  if (data !== null && data !== void 0 && data.error) {
    log.error('useCloudMigrationData', "Failed to retrieve Cloud Migration Opt In Data", {
      error: data.error
    });
  }
  return {
    cloudMigrationData: data,
    showCloudMigrationError: !!(data !== null && data !== void 0 && data.error),
    showCloudMigrationData: enableCloudMigrationToggle && data && !(data !== null && data !== void 0 && data.error)
  };
};